<template>
  <van-dialog
    v-bind="options"
    v-model="localVisible"
    @cancel="handleCancel"
    @confirm="handleConfirm"
    class="custom-dialog"
    :class="!options.closeIcon && options.showCloseIcon ? 'hascancel' : ''"
  >
    <!-- 自定义关闭图标 -->
    <img v-if="options.closeIcon && options.showCloseIcon" src="@/assets/images/cartojourney/img33.png" @click="handleClose" class="icon-close" alt="关闭" />
    <!-- 对话框内容 -->
    <div class="dialog-content">
      <slot></slot>
      <!-- 允许父组件传递自定义内容 -->
    </div>
  </van-dialog>
</template>

<script>
export default {
  name: 'CustomDialog',
  props: {
    // 控制对话框显示状态
    visible: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      localVisible: this.visible,
      options: {
        title: '提示',
        showCancelButton: true,
        cancelButtonText: '取消',
        confirmButtonText: '确认',
        closeIcon: true,
        showCloseIcon: true
      }
    }
  },
  watch: {
    visible(newVal) {
      this.localVisible = newVal
      this.options = Object.assign({}, this.options, this.$attrs)
    },
    $attrs() {
      this.options = Object.assign({}, this.options, this.$attrs)
    }
  },
  methods: {
    handleCancel() {
      this.$emit('update:visible', false)
      this.$emit('cancel')
    },
    handleConfirm() {
      this.$emit('update:visible', false)
      this.$emit('confirm')
    },
    handleClose() {
      this.$emit('update:visible', false)
      this.$emit('close')
    }
  }
}
</script>

<style lang="less" scoped>
.custom-dialog {
  width: 320px;
  background: #fff;
  border-radius: 8px;

  &.hascancel {
    /deep/ .van-dialog__footer {
      .van-dialog__cancel {
        .van-button__content {
          border: none;
          background: rgba(0, 0, 0, 0.08);

          .van-button__text {
            color: #7A8494;
          }
        }
      }
    }
  }

  .icon-close {
    position: absolute;
    right: 15px;
    top: 15px;
    width: 20px;
    cursor: pointer; /* 添加鼠标悬停样式 */
  }

  .dialog-content {
    font-family: "Source Han Sans CN, Source Han Sans CN", sans-serif;
    font-weight: 400;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.8);
    line-height: 25px;
    text-align: center;
    width: 280px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 20px;
    margin-bottom: 36px;
  }

  /deep/ .van-dialog__footer {
    background-color: transparent;
    overflow: visible;

    &::after {
      display: none;
    }

    .van-button {
      background-color: transparent;
      border: none;
      padding: 0;

      &::after {
        display: none;
      }

      &.van-dialog__confirm .van-button__content {
        color: #fff;
        background-color: #eb1700;
      }

      .van-button__content {
        width: 130px;
        height: 42px;
        text-align: center;
        line-height: 42px;
        border: 1px solid #eb1700;
        border-radius: 100px;
        color: #eb1700;
        margin-left: 50%;
        transform: translateX(-50%);
        bottom: 12px;
        position: relative;
      }
      &:active::before {
        opacity: 0;
      }
    }
  }

  .txts {
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 400;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.8);
    line-height: 21px;
    text-align: center;
    width: 270px;
    margin-top: 20px;
    margin-bottom: 36px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/cartoJourney/components/CustomDialog.vue